import api from '../apis/ufrnApi'

export const libraryHasMap = sigaaId => {
    const libraries = [661399, 723664]
    return libraries.includes(sigaaId)
}

const locationService = (libraryId, meterialId) => {
    const materialIdFormated = encodeURI(meterialId)
    let url = `/localizar/${libraryId}?cdu=${materialIdFormated}`
    return api.get(url)
}

export default locationService